import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { EntAnimalBreed } from "../../../../models/handBooks/animalBreed";
import { useAddAnimalBreedMutation, useDeleteAnimalBreedMutation, useEditAnimalBreedMutation } from "../../../../redux/api/handBooksApi/animalBreadApi";



const useAnimalBreed = (modal: any, refresh?: () => void) => {
    const { t } = useTranslation()
    const { confirm } = modal;
    const [addAnimalBreed] = useAddAnimalBreedMutation();
    const [deleteAnimalBreed] = useDeleteAnimalBreedMutation();
    const [editAnimalBreed] = useEditAnimalBreedMutation();


    async function onAddAnimalBreed(newAnimalBreed: EntAnimalBreed): Promise<boolean> {
        try {
            let status: boolean = false;
            await addAnimalBreed(newAnimalBreed).then((response: any) => {
                if (response.error !== undefined) {
                    
                    throw new Error(response.error.data.message);
                }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if(refresh) refresh();
                }
            }).catch((error:any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });
          
            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }
    async function onDeleteAnimalBreed(animalBreed: EntAnimalBreed) {
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteAnimalBreed(animalBreed.id).then((response: any) => {
                        if (response.error !== undefined && response.error.status === 400) {
                            status = false;
                            throw new Error(response.error.data.message);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({title: t('msg.successDelete')});
                            if(refresh) refresh();
                        }
                    }).catch((error: any) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });
                        
                    });
                }
            })
            return status
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    async function onEditAnimalBreed(editedAnimalBreed: EntAnimalBreed): Promise<boolean> {
        try {
            let status: boolean = false;
            await editAnimalBreed(editedAnimalBreed).then((response: any) => {
                if (response.error !== undefined && response.error.status === 400) {
                    throw new Error(response.error.data.message);
                }
                if (response.data.success) {
                    status = true;
                    Modal.success({title: t('msg.successEdited')});
                    if(refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    return { onAddAnimalBreed,onDeleteAnimalBreed, onEditAnimalBreed }

}
export { useAnimalBreed };

